<template>
    <Head>
        <title>Dependencias Municipales</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-secretarias-direcciones.png');">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-7">
            <h1 class="hero-encabezado">Dependencias Municipales</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="bloque-general">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="encabezado-separador"><span>Conoce nuestras Dependencias Municipales</span></h2>
          </div>
        </div>
        <div class="row">
          <div v-for="(item, index) in secretarias" :key="index" class="col-md-6 col-lg-4">
            <div class="tarjeta-info_sec">
              <div class="tarjeta-info_inner">
                <div class="tarjeta-info_encabezado">
                  <img loading="lazy" width="46" height="40" class="tarjeta-info_icono" :src="'/img/icono-hexagono-'+item.icono+'.svg'" alt="">
                  <div class="tarjeta-info_titulo">
                    <h6 class="tarjeta-info_nombre">{{ item.nombre }}</h6>
                  </div>
                </div>
                <div class="tarjeta-info_cuerpo">
                  <div class="tarjeta-info_puesto">
                    <div class="tarjeta-info_label">Titular:</div>
                    <span class="tarjeta-info_info">{{ item.secretario }}</span>
                  </div>
                  <div class="tarjeta-info_direccion">
                    <div class="tarjeta-info_label">Dirección</div>
                    <a :href="item.mapa" target="_blank">¿Cómo llegar?</a>
                    <span class="tarjeta-info_info">{{ item.direccion }}</span>
                  </div>
                </div>
              </div>
              <div class="tarjeta-info_contacto">
                <div class="tarjeta-info_contacto-inner">
                  {{ item.telefono }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    props:{
        secretarias: Object,
    }
}
</script>
<style scoped>

</style>
